export enum FILTER_VALUES {
    BOTH = 'both',
    FRUIT = 'fruit',
    PLANT = 'plant',
}

export const FILTER_STORAGE_KEY = 'typeFilter'